import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {	
		encuestas : []
	},
	getters: {		
		getEncuestas : state => state.encuestas
	},
	actions: {
        requestEncuestas({commit}){
            return new Promise((resolve, reject) => {
                axios.get('/api/TutorAcademico/dameEncuestasUsuario').then(response => {
                    if (response.data.status == 0) {
                        commit('setEncuestas', response.data.datos);
                        // resolve(response.data.datos);
                    } else {
                        resolve(false);
                        commit('setError', response.data.status);
                    }
                }).catch(function (error) {
                    reject(false);
                    dispatch('sendErrorServer', error.response);
                });
            });
        }
	},
	mutations: {    
        setEncuestas(state, encuestas){
            console.log(encuestas);
            state.encuestas = encuestas;
        }
	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/encuestas.js